module.exports = __webpack_public_path__ + "media/images/home/studenti03-7bbe1e9a1517c6d3151cb9c446abd939.svg";